import React from "react";

import { useState, useEffect } from "react";
import Login from "./Login";
import TitleWithDropdown from "./TitleWithDropdown";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import image from "../logos/calendar.png";
import {
  setCurrentEmms,
  setLogoutCurrentEmms,
} from "../redux/slices/currentEmmsSlice";
import { setEmmsHeaders, setEmmsLogout } from "../redux/slices/emmsAuthSlice";

import CalendarTable from "./CalendarTable";
import MyCalendarForm from "./MyCalendarForm";
import { setCalendar } from "../redux/slices/calendarSlice";

function CalendarDashboard() {
  const dispatch = useDispatch();
  const emms = useSelector((state) => state.emms);
  const [login, setLogin] = useState(false);
  let selectedEmms = null;
  const [responseData, setResponseData] = useState([]);
  const headers = useSelector((state) => state.header);
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(emms?.emms?.[0]?.id);

  function fetchData(value) {
    setIsLoading(true);
    let selectedEmms = emms?.emms?.find((element) => element.id === value);
    dispatch(setCurrentEmms(selectedEmms));

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      const requestBody = {
        path: "calendar",
        query: {},
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };
      const api = localStorage.getItem("api");
      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          dispatch(setCalendar(response.data));
          setResponseData(response.data);
          setErrors(false);
        })
        .catch((error) => {
          console.error(error);
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  useEffect(() => {
    fetchData(selectedOption);
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event?.target?.value);
    fetchData(event?.target?.value);
  };

  const options = emms?.emms?.map((emm) => ({
    label: emm.name,
    value: emm.id,
  }));

  return login == null ? (
    <Login />
  ) : (
    <>
      <div className="mainContainer emms-main-container">
        <header className="no-margin">
          <figure>
            <img className="img" src={image} alt="Logo" />
          </figure>
        </header>
        <div className="title-container">
          <div className="title">
            <TitleWithDropdown
              title="EMMS Service"
              options={options}
              selectedOption={selectedOption}
              onOptionChange={handleOptionChange}
            />
          </div>
          <div>
            <MyCalendarForm selectedOption={selectedOption} />
          </div>
        </div>
        <div className="emms-main-container-left-align" style={{ marginLeft: "10%" }}>
          <CalendarTable selectedOption={selectedOption} errors={errors} isLoading={isLoading} />
        </div>
      </div>
    </>
  );
}

export default CalendarDashboard;
